export default __webpack_public_path__ + "static/media/templates.9e88926a.png";